import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/lakaData";

const Testimonials = () => (
  <section
    id="opiniones"
    data-testid="testimonials-section"
    className="py-24 md:py-32"
    style={{ background: "#FBF6F2" }}
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="text-center mb-14">
        <span className="laka-eyebrow">Opiniones</span>
        <h2 className="mt-4 font-serif-laka text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] text-[#1A1A1A]">
          Historias que <span className="italic text-[#D6B36A]">nos inspiran</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <figure
            key={t.author}
            data-testid={`testimonial-${i}`}
            className="p-7 laka-card flex flex-col"
          >
            <Quote
              className="w-6 h-6 text-[#D6B36A]"
              strokeWidth={1.2}
            />
            <blockquote className="mt-4 font-serif-laka text-xl md:text-[1.35rem] text-[#1A1A1A] leading-snug flex-1">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-6 pt-5 border-t border-[#D6B36A]/25">
              <div className="text-sm text-[#1A1A1A] font-medium">
                {t.author}
              </div>
              <div className="text-[0.65rem] tracking-[0.24em] uppercase text-[#1A1A1A]/50 mt-1">
                {t.role}
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
